import '../plugins/stickyScrollBlockPlugin';




// initialize fixed blocks on scroll
export default function initStickyScrollBlock() {
	ResponsiveHelper.addRange({
		'1024..': {
			on: function() {
				jQuery('.sticky-block').stickyScrollBlock({
					setBoxHeight: true,
					activeClass: 'fixed-position',
					container: '.category-section',
					positionType: 'fixed',
					extraTop: 150,
					extraBottom: 100
				});
			},
			off: function() {
				jQuery('.sticky-block').stickyScrollBlock('destroy');
			}
		}
	});
}